import { useState } from 'react'
import { create } from "../../../../Context/api";
import { teamAddValidation } from '../../../../Context/validation';
import axios from "axios";
import { commonMessage, statusCodes } from "../../../../Constants/generalConfig";
import {  toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { isValidPhoneNumber } from 'react-phone-number-input';

const UseAddTeam = () => {
    const [spinner, setSpinner] = useState(false)
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    const teamAdd = useFormik({
        initialValues: {
            name: '',
            email: '',
            mobileNo: '',
            providerName: '',
            description: '',
        },
        validationSchema: teamAddValidation,
        validate: (values) => {
            const errors = {};
            if (values?.mobileNo?.length > 0 && (values?.mobileNo && isValidPhoneNumber(values?.mobileNo))) {
                delete errors.mobileNo
            } else {
                errors.mobileNo = "Please enter a valid mobile number ";
            }
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                email: values.email.trim(),
                mobileNo: values.mobileNo,
                createdbyId: adminData?.userId
            }
            // console.log(data, 'lllll')
            axios.post(create(), data).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    teamAdd.resetForm()
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000);
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                    setSpinner(false)
                })
        }
    })
  return {
    spinner,
    teamAdd
  }
}

export default UseAddTeam